/** @format */

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { BreadCrumb } from "../../../../components";
// import moment from "moment";
// import "moment/locale/id";
import axios from "axios";
import { Table, Space, Modal, Tabs, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  ButtonTableDelete,
  ButtonTableEdit,
  ButtonTambah,
} from "../../../../components/Button";
import InputSearch from "../../../../components/InputSearch";
import ModalPengajuanDokumen from "../Component/ModalDokumenPengajuan";
import { deleteDokumenPengajuanBOS } from "../../../../services/v2/planningservice/rencanapengajuanbos";
import notifAlert from "../../../../components/NotifAlert";
import {
  getBerkasRencana,
  getPlanningAll,
} from "../../../../services/v2/planningservice";
import { setBos } from "../../../../redux/actions/bosAction";
import { planningService } from "../../../../services/v2/constant";
import ModalLihatDokumenBos from "../../../../components/Modal/ModalLihatDokumenBos";
import {
  // getFirstSumberDanaBOS,
  getNamePenerimaBOS,
} from "../../../../utils/helper/helperBos";
export const baseURL: string =
  window.REACT_APP_API_URL ||
  // "https://api-gateway.erkam-v2.kemenag.go.id/api";
  "https://staging-api-gateway.erkam-v2.kemenag.go.id/api";
export const publicURL: string =
  window.REACT_APP_PUBLIC_URL ||
  "https://staging-frontend.erkam-v2.kemenag.go.id/";
const { TabPane } = Tabs;

const DokumenPengajuan = () => {
  const route = useHistory();
  const dataState: any = route ? route.location.state : null;
  const dispatch = useDispatch();
  const store = useSelector((state: any) => state.store);
  const auths = useSelector((state: any) => state.auth);
  const bos = useSelector((state: any) => state.bos);
  const [loading, setLoading] = useState<any>(false);
  const tmpSumberDana = store.sumberDana || [];
  const tmpFilePengajuanBos = bos.filePengajuanBos || [];
  const [pdfFile, setPdfFile] = useState<any>(null);
  const typePenerimaBOS = getNamePenerimaBOS();
  const nameSumberDana =
    tmpSumberDana.length &&
    tmpSumberDana.find((item) => item.kode === dataState.sumberdana);
  const itemBreadcrumb = [
    { path: "/", breadcrumbName: "Home" },
    { path: "/", breadcrumbName: "Pengaturan" },
    { path: "/", breadcrumbName: "Tanggal Pengajuan BOS" },
    { path: "/", breadcrumbName: "Dokumen Pengajuan" },
    {
      path: "/",
      breadcrumbName: `${nameSumberDana.nama} Batch ${dataState.batch}`,
    },
  ];
  const [search, setSearch] = useState<any>(null);
  const [activeTabKey, setActiveTabKey] = useState<any>(3);
  const [title, setTitle] = useState<any>(null);
  const [dataDoc, setDataDoc] = useState<any>(null);
  const [openModal, setOpenModal] = useState<any>(false);
  const [openModalPriview, setOpenModalPriview] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  let dataTable = search
    ? tmpFilePengajuanBos
        .filter(
          (item: any) =>
            item.djadwal_pengajuan_id === dataState?.id &&
            item.penerima_bos.toString() === activeTabKey.toString(),
        )
        .filter((item: any) => {
          const val = search.toLowerCase();
          return (
            (item.nama !== null &&
              (item.nama || "").toLowerCase().includes(val)) ||
            (item.kode !== null &&
              (item.kode || "").toLowerCase().includes(val))
          );
        })
    : tmpFilePengajuanBos.filter(
        (item: any) =>
          item.djadwal_pengajuan_id === dataState?.id &&
          item.penerima_bos.toString() === activeTabKey.toString(),
      );

  let totalDataTable = dataTable.length;
  /**
   * Filter Pagination
   */
  dataTable = dataTable
    // .sort((a, b) => (parseInt(a.batch) < parseInt(b.batch) ? 1 : -1))

    .filter((v, i) => {
      let start = pageSize * (page - 1);
      let end = start + pageSize;

      return i >= start && i < end;
    });

  const handleTambah = () => {
    setTitle("Tambah");
    setOpenModal(true);
    setDataDoc(null);
  };

  // const handleSimpan = (values: any) => {};
  const getData = async () => {
    try {
      const filePengajuanBos = await getPlanningAll("doc-template", {
        tahun: auths.isTahun,
      });
      dispatch(setBos({ filePengajuanBos }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (record: any) => {
    setTitle("Edit");
    setOpenModal(true);
    setDataDoc(record);
  };

  const handleDelete = async (record: any) => {
    try {
      await deleteDokumenPengajuanBOS(record.id);

      notifAlert({
        type: "success",
        description: "Data berhasil dihapus",
      });
      getData();
    } catch (error) {
      console.log(error);
    }
  };

  const getDownloadDokumen = async (params: any) => {
    axios
      .get(
        `${baseURL}${planningService}/dokumen-rencana-definitif/download?fileName=${params}`,
        {
          withCredentials: false,
          responseType: "arraybuffer",

          headers: {
            Accept: "application/pdf",
            "Content-Type": "application/pdf",
            "Access-Control-Allow-Headers":
              "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-Erkam-Year",
            "Access-Control-Allow-Credentials": true,
            Authorization: "Bearer " + auths?.data?.token,
            "X-Erkam-Year": auths?.isTahun,
          },
        },
      )
      .then(function (response: any) {
        setOpenModalPriview(true);
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        setPdfFile(link);
        setLoading(false);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        setLoading(false);
      });
  };

  const handleOpenDokumen = async (record: any) => {
    let dokumenRab: any = [];
    setLoading(true);
    try {
      let res = await getBerkasRencana(
        record?.id,
        dataState?.id,
        auths.isTahun,
      );

      if (res) {
        dokumenRab.push(res);
        getDownloadDokumen(res?.fileName);
      }
    } catch (error) {
      notifAlert({
        type: "error",
        description: "File Tidak ditemukan!!",
      });
      console.log(error);
    }
    setLoading(false);
  };

  const columns: any = [
    {
      title: "Kode",
      dataIndex: "kode",
      key: "kode",
    },
    {
      title: "Nama",
      dataIndex: "nama",
      key: "nama",
    },
    {
      title: "Jenis",
      dataIndex: "jenis_doc",
      key: "jenis_doc",
    },
    {
      title: "Periode",
      dataIndex: "periode",
      key: "periode",
      render: (periode, record) => {
        let periodeSumberDana: any = periode?.sumberDana || "";
        let periodeMonth: any = periode?.isMonth || [];
        let periodeYear: any = periode?.isYear || "";

        return (
          <>
            {record?.kode === "docLpj" && (
              <>
                <div>Sumber Dana : {periodeSumberDana}</div>
                <div>Periode : {periodeMonth.join(",")}</div>
                <div>Tahun : {periodeYear}</div>
              </>
            )}
          </>
        );
      },
    },
    {
      title: "Type File Upload",
      dataIndex: "typedoc",
      key: "typedoc",
    },
    {
      title: "Template",
      key: "template",
      render: (record) => {
        if (record?.jenis_doc === "dokumen" && record?.namatemplate) {
          return (
            <>
              <Button
                loading={loading}
                onClick={() => handleOpenDokumen(record)}>
                Lihat Dokumen
              </Button>
            </>
          );
        }
      },
    },
    {
      title: "Aksi",
      key: "aksi",
      render: (record: any) => (
        <Space size="small">
          <ButtonTableEdit onClick={() => handleEdit(record)} />
          <ButtonTableDelete
            onClick={() => {
              Modal.confirm({
                title: "Perhatian",
                content: "Yakin Hapus Data?",
                onOk() {
                  return handleDelete(record);
                },
                onCancel() {},
                okText: "Selesai",
                cancelText: "Batal",
                okType: "danger",
              });
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <BreadCrumb
        routes={itemBreadcrumb}
        title={`Dokumen Pengajuan  ${nameSumberDana.nama} Batch ${dataState.batch}`}
        back={true}
        toBack={() =>
          route.push({
            pathname: "../../tanggal-pengajuan-bos",
            state: {
              page: dataState?.page || 1,
              pageSize: dataState?.pageSize || 10,
            },
          })
        }
        footer={
          <Tabs
            defaultActiveKey={activeTabKey}
            size="small"
            onChange={(key) => {
              setActiveTabKey(key);
            }}>
            {typePenerimaBOS
              // eslint-disable-next-line array-callback-return
              .filter(
                (item: any, i: any) =>
                  // (!getFirstSumberDanaBOS().includes(nameSumberDana?.kode) &&
                  //   true) ||
                  // i !== 2,
                  (dataState?.jenisPenerima &&
                    dataState.jenisPenerima.includes(item.kode.toString())) ||
                  false,
              )
              .map((item: any, i: any) => {
                return (
                  <TabPane
                    tab={`${item.name} ${auths.isTahun}`}
                    key={item.kode}
                  />
                );
              })}
          </Tabs>
        }
      />
      <div className="m-5 p-5 bg-white shadow-md rounded">
        <div className="mb-4 flex justify-end">
          <div className="mr-4">
            <ButtonTambah onClick={handleTambah} />
          </div>
          <InputSearch
            className="w-3/4"
            onChange={(e: any) => setSearch(e.currentTarget.value)}
          />
        </div>

        <div className="w-full">
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            tableLayout="auto"
            dataSource={dataTable}
            bordered
            pagination={{
              total: totalDataTable,
              position: ["bottomRight"],
              defaultPageSize: pageSize,
              defaultCurrent: page,
              showTotal: (total) => `Total ${total} items`,
              onChange(page, pageSize) {
                setPage(page);
                setPageSize(pageSize);
              },
            }}
          />
        </div>
      </div>
      <ModalPengajuanDokumen
        openModal={openModal}
        title={title}
        store={store}
        dokumenId={dataState}
        data={dataDoc}
        isAuth={auths}
        handleOpenDokumen={handleOpenDokumen}
        handleGetData={getData}
        handleClose={() => {
          setOpenModal(!openModal);
          setDataDoc(null);
        }}
      />
      <ModalLihatDokumenBos
        onClose={() => setOpenModalPriview(!openModalPriview)}
        openModalPriview={openModalPriview}
        pdfFile={pdfFile}
      />
    </>
  );
};
export default DokumenPengajuan;
